export default "__VITE_ASSET__DER2Nw0O__"